<template>
  <auth-layout>
    <card title="404 error">
      <p>Oh no! Page not found.</p>
      <template v-slot:footer>
        <router-link v-if="isLoggedIn" to="/">Home</router-link>
        <router-link v-else to="/login">Login</router-link>
      </template>
    </card>
  </auth-layout>
</template>

<script>
import AuthLayout from "../layout/AuthLayout.vue";
import auth from "../services/auth";

export default {
  components: {
    AuthLayout
  },
  computed: {
    isLoggedIn() {
      return auth.isLoggedIn();
    }
  }
};
</script>
